export default "__VITE_ASSET__hC7AqcrN__"